export default "/images/testBackground5.png?45738986df7f28ed8de76a1b850f3489";